module.exports = __webpack_public_path__ + "static/media/thenewshuffle2.df95036a.png";